import React from 'react';
import cn from 'classnames';
import Spinner from '@dealroadshow/uikit/core/components/Loader/Spinner';
import Button, { ButtonVariantType } from '@dealroadshow/uikit/core/components/Button';
import IconArrowLeft from '@dealroadshow/uikit/core/components/Icon/IconArrowLeft';
import { useStepFormContext } from '@/finsight/application/PortfolioMonitor/StepFormContext';

import cardStyles from '@dealroadshow/uikit/core/styles/card.scss';
import portfolioStyles from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/portfolioContent.scss';
import styles from './styles.scss';

interface IProps {
  isLoading?: boolean,
  isSubmitDisabled: boolean,
  caption?: string,
  onCancelClick: () => void,
  submitButtonTitle?: string,
}

const FormBottomNavigation = ({ isLoading, isSubmitDisabled, caption, onCancelClick, submitButtonTitle = 'Continue' }: IProps) => {
  const { goPrev } = useStepFormContext();

  return (
    <div className={ cn(styles.formFooter, cardStyles.cardInnerHorizontal) }>
      <Button
        variant={ ButtonVariantType.link }
        dataTest="portfolioMonitorBackButton"
        onClick={ goPrev }
      >
        <IconArrowLeft />
        Back
      </Button>
      { caption && (
        <div className={ styles.caption }>
          { caption }
        </div>
      ) }
      <div>
        <Button
          variant={ ButtonVariantType.link }
          dataTest="portfolioMonitorCancelButtonButton"
          onClick={ onCancelClick }
          className={ styles.cancelButton }
        >
          Cancel
        </Button>
        <Button
          variant={ ButtonVariantType.action }
          dataTest="portfolioMonitorContinueButtonButton"
          type="submit"
          disabled={ isSubmitDisabled }
        >
          { isLoading ? <Spinner className={ portfolioStyles.spinner } /> : submitButtonTitle }
        </Button>
      </div>
    </div>
  );
};

export default FormBottomNavigation;
